<template>
  <div id="app">
        <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
//禁止鼠标右键
window.oncontextmenu = function(){
    return false;
};
</script>
<style  lang='less'  rel="stylesheet/less">
@import './assets/css/index.less';
#app {
 font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body{
  background: #CBCBCB;
}

</style>



// WEBPACK FOOTER //
// src/App.vue